import axiosInstance from "../../../../axios/axios";

export class UsersService {
    static async filterOwnersOrUsers({ language, ownerId, skip = 0, take = 10000, tableType = "user" }) {
        try {
            const response = await axiosInstance.post("/StudBook/FilterOwnersOrUsers", {
                langauge: language,
                ownerId,
                skip,
                take,
                tableType,
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching owners/users:", error);
            throw error;
        }
    }
}
